import { FC, useState } from 'react'
import { Input, Modal } from 'antd'
import { translate } from '../../../core'

const STONE_EDIT_PASSWORD = 'dog'

type StonePasswordModalProps = {
  open: boolean
  onCancel: () => void
  onSuccess: () => void
}

export const StonePasswordModal: FC<StonePasswordModalProps> = ({open, onCancel, onSuccess}) => {
  const [password, setPassword] = useState<string>('')
  const [error, setError] = useState<string>()

  const reset = () => {
    setPassword('')
    setError(undefined)
  }

  const handleOk = () => {
    if (password.trim().toLowerCase() === STONE_EDIT_PASSWORD) {
      reset()
      onSuccess()
    } else {
      setError(translate('incorrect_password_message'))
    }
  }

  const handleCancel = () => {
    reset()
    onCancel()
  }

  return (
    <Modal
      open={open}
      title={translate('enter_password')}
      width='30%'
      onCancel={handleCancel}
      onOk={handleOk}
      okText={translate('confirm')}
      destroyOnClose
    >
      <label>{translate('password')}</label>
      <Input.Password
        autoFocus
        value={password}
        status={error ? 'error' : undefined}
        onChange={e => {
          setPassword(e.target.value)
          if (error) setError(undefined)
        }}
        onPressEnter={handleOk}
      />
      {error ? (
        <div style={{color: '#ff4d4f', marginTop: 4}}>{error}</div>
      ) : null}
    </Modal>
  )
}
